module.exports = __webpack_public_path__ + "img/blue-back.a9e5affb.png";